/**
 * signupEnabled.ts — the ONE build-time switch for the multi-tenant sign-up work.
 *
 * ON only when `REACT_APP_SIGNUP_ENABLED` is the exact string "true".
 * DEFAULT: OFF.
 *
 * Why a build-time switch: CRA inlines `process.env.REACT_APP_*` at BUILD time,
 * so this is a constant per build — there is no runtime toggle and no server
 * round-trip. With the switch OFF, a production build behaves like the site
 * before any sign-up work existed (commit 327ec47): no sign-up entry points, no
 * sign-up routes, and log-in makes NO calls to the sign-up functions
 * (auth-email / signup-email), which do not exist in production yet.
 *
 * Local development: put `REACT_APP_SIGNUP_ENABLED=true` in `.env.local`
 * (never committed). Launch day: set it to `true` in the production build.
 *
 * Read at CALL time (not module scope) so tests can flip it and so nothing
 * depends on import order.
 */
export function isSignupEnabled(): boolean {
  // NOTE: the literal member access is deliberate — CRA only inlines
  // `process.env.REACT_APP_<NAME>`, never a dynamic lookup.
  return process.env.REACT_APP_SIGNUP_ENABLED === 'true';
}